import { defineMessages } from '@sm/intl';

const FORMS = 'GROW-2529';
const TYPE_DESCRIPTION = '[Type: String][Vis.: high] - ';
const EXPERIMENT_DESCRIPTION = ' - A string in pricing experiment GROW-2529';
const FORM_DETAILS_TABLE = 'form details table';

const experimentDetailsCopy = defineMessages({
  grow_2529_analysis_filter: {
    id: 'Pricing.experimentDetailsCopy.AnalysisFilter',
    defaultMessage: '1 analysis filter',
    desc: {
      id: 'Pricing.experimentDetailsCopy.AnalysisFilter',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TABLE} label ${EXPERIMENT_DESCRIPTION} (new)`,
      project: FORMS,
    },
  },
  grow_2529_survey_create_limit: {
    id: 'Pricing.experimentDetailsCopy.SurveyCreateLimit',
    defaultMessage: 'Number of forms & surveys',
    desc: {
      id: 'Pricing.experimentDetailsCopy.SurveyCreateLimit',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TABLE} label ${EXPERIMENT_DESCRIPTION} (new)`,
      project: FORMS,
    },
  },
  grow_2529_questions_per_form_survey: {
    id: 'Pricing.experimentDetailsCopy.QuestionsPerFormSurvey',
    defaultMessage: 'Questions per form or survey',
    desc: {
      id: 'Pricing.experimentDetailsCopy.QuestionsPerFormSurvey',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TABLE} label ${EXPERIMENT_DESCRIPTION} (new)`,
      project: FORMS,
    },
  },
  grow_2529_form_survey_capabilities: {
    id: 'Pricing.experimentDetailsCopy.FormSurveyCapabilities',
    defaultMessage: 'Form & Survey Capabilities',
    desc: {
      id: 'Pricing.experimentDetailsCopy.FormSurveyCapabilities',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TABLE} heading ${EXPERIMENT_DESCRIPTION} (new)`,
      project: FORMS,
    },
  },
  // IDs matching existing names in GraphQL API response
  grow_2529_recurring_surveys: {
    id: 'Pricing.experimentDetailsCopy.RecurringFormsSurveys',
    defaultMessage: 'Recurring forms & surveys',
    desc: {
      id: 'Pricing.experimentDetailsCopy.RecurringFormsSurveys',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TABLE} label ${EXPERIMENT_DESCRIPTION} (override)`,
      project: FORMS,
    },
  },
  grow_2529_payment_qt: {
    id: 'Pricing.experimentDetailsCopy.AcceptPayments',
    defaultMessage: 'Accept payments',
    desc: {
      id: 'Pricing.experimentDetailsCopy.AcceptPaymentsDesc',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TABLE} label ${EXPERIMENT_DESCRIPTION} (override)`,
      project: FORMS,
    },
  },
  grow_2529_skip_logic: {
    id: 'Pricing.experimentDetailsCopy.SkipLogicOnly',
    defaultMessage: 'Skip logic only',
    desc: {
      id: 'Pricing.experimentDetailsCopy.SkipLogicOnly',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TABLE} label ${EXPERIMENT_DESCRIPTION} (override)`,
      project: FORMS,
    },
  },
  grow_2529_survey_builder: {
    id: 'Pricing.experimentDetailsCopy.FormSurveyBuilder',
    defaultMessage: 'Form & Survey Builder',
    desc: {
      id: 'Pricing.experimentDetailsCopy.FormSurveyBuilder',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TABLE} heading ${EXPERIMENT_DESCRIPTION} (new)`,
      project: FORMS,
    },
  },
  grow_2529_database_response_view: {
    id: 'Pricing.experimentDetailsCopy.DatabaseResponseView',
    defaultMessage: 'Database response view',
    desc: {
      id: 'Pricing.experimentDetailsCopy.DatabaseResponseView',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TABLE} heading ${EXPERIMENT_DESCRIPTION} (new)`,
      project: FORMS,
    },
  },
  best_worst_qt: {
    id: 'Pricing.experimentDetailsCopy.BestWorstQt',
    defaultMessage: 'Best worst scale',
    desc: {
      id: 'Pricing.experimentDetailsCopy.BestWorstQt',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TABLE} heading ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
  grow_2529_use_collectors: {
    id: 'Pricing.experimentDetailsCopy.UseCollectors',
    defaultMessage: 'Use {number} collectors per form or survey',
    desc: {
      id: 'Pricing.experimentDetailsCopy.UseCollectors',
      message: `${TYPE_DESCRIPTION} ${FORM_DETAILS_TABLE} details ${EXPERIMENT_DESCRIPTION}`,
      project: FORMS,
    },
  },
});

export default experimentDetailsCopy;
